import { useEffect, useRef, useState } from 'react'

/**
 * True for a moment each time `count` goes up.
 *
 * Drives the bell's arrival pulse. Watching the count rather than the store's
 * events means it fires once per notification however it was raised, and never
 * on a decrease — marking the page read must not look like something new
 * landed.
 */
export function useArrival(count: number, duration = 1100): boolean {
  const previous = useRef(count)
  const [arriving, setArriving] = useState(false)

  useEffect(() => {
    const rose = count > previous.current
    previous.current = count
    if (!rose) return

    // Restart cleanly if a second lands mid-pulse: without the false frame the
    // class never leaves the element and the animation does not replay.
    setArriving(false)
    const start = window.setTimeout(() => setArriving(true), 0)
    const end = window.setTimeout(() => setArriving(false), duration)

    return () => {
      window.clearTimeout(start)
      window.clearTimeout(end)
    }
  }, [count, duration])

  return arriving
}
